import React from 'react';
import Copy from '@nib-components/copy';
import Link from '@nib-components/link';

export function getExtraNibSections(brandConfig, clickHandler) {
  return brandConfig.brandName === 'nib'
    ? [
        {
          title: 'How do I log in to the nib App?',
          children: (
            <>
              <ol>
                <li>
                  Download the nib App from the <Link onClick={() => clickHandler('https://itunes.apple.com/au/app/nib-health-insurance/id373883175?mt=8', 'download_link_click')}>App Store</Link> or{' '}
                  <Link onClick={() => clickHandler('https://play.google.com/store/apps/details?id=au.com.nib&hl=en', 'download_link_click')}>Google Play</Link>.
                </li>
                <li>Open the app and select Log in.</li>
                <li>Enter the email address or phone number registered to your policy and select Next.</li>
                <ul>
                  <li>If you choose to log in with your phone number, then you will also be prompted to enter your member number. Your member number can be found on the front of your nib card</li>
                </ul>
                <li>A verification code will be sent to you. Enter the code and select Next.</li>
                <li>You’ll then be prompted to enable Touch ID or Facial recognition and a 4-digit pin for easy login in the future.</li>
              </ol>
            </>
          ),
        },
        {
          title: 'How do I log in to the nib website?',
          children: (
            <>
              <ol>
                <li>
                  Go to <Link onClick={() => clickHandler('https://www.nib.com.au/onlineservices', 'mynib_click')}>My nib</Link> at the top of the website.
                </li>
                <li>Once the log in page appears, select Login.</li>
                <li>Enter the email address or phone number registered to your policy and select Next.</li>
                <ul>
                  <li>If you choose to log in with your phone number, then you will also be prompted to enter your member number. Your member number can be found on the front of your nib card</li>
                </ul>
                <li>A verification code will be sent to you. Enter the code and select Next.</li>
              </ol>
            </>
          ),
        },
        {
          title: 'Is your device up to date and do you have the latest version of the nib App?',
          children: (
            <>
              <Copy measure={false}>
                We support the latest iOS and Android software. If you're having trouble logging in to the nib App, make sure you have downloaded the latest version. For Android users, the nib App is
                only available on Google Play if your country is set to Australia.
              </Copy>
            </>
          ),
        },
      ]
    : [];
}
